import arrayHelper from './arrayHelper';

export default class objectHelper {
  static Equals(first, second) {
    if (first === second) return true;
    if (arrayHelper.BothIsArray(first, second)) {
      return arrayHelper.Equals(first, second);
    }

    if (Object.keys(first).length !== Object.keys(second).length) return false;

    for (const key in first) {
      if (first[key] !== second[key]) {
        if (objectHelper.BothIsObject(first[key], second[key])) {
          if (!objectHelper.Equals(first[key], second[key])) return false;
        } else {
          return false;
        }
      }
    }
    return true;
  }

  static BothIsObject(first, second) {
    return typeof first === 'object' && typeof second === 'object';
  }

  static toString(o) {
    Object.keys(o).forEach((k) => {
      if (typeof o[k] === 'object') {
        return toString(o[k]);
      }
      o[k] = `${o[k]}`;
    });
    return o;
  }

  // Value equality for isThereAnySearchParameter: strict for primitives, element-wise for
  // arrays, timestamp-based for dates.
  static valuesEqual(a, b) {
    if (a === b) return true;
    if (Array.isArray(a) && Array.isArray(b)) {
      return a.length === b.length && a.every((value, index) => objectHelper.valuesEqual(value, b[index]));
    }
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    return false;
  }

  /**
   * Returns `value` as an instance of `type`. If it already is one, it is
   * returned unchanged; otherwise a plain object — e.g. the result of a
   * `{ ...obj }` spread, which keeps the data but drops the prototype — is
   * rehydrated onto the type's prototype so its instance methods work again.
   * No constructor runs (so no side effects), and a NEW object is returned when
   * rehydrating: the input is never mutated.
   *
   * @template T
   * @param {T | object} value the value to coerce (a live instance or a plain object)
   * @param {new (...args: any[]) => T} type the class to (re)attach
   * @returns {T}
   */
  static asInstanceOf(value, type) {
    if (value instanceof type) return value;
    return Object.assign(Object.create(type.prototype), value);
  }
}
